// Kjøp, hovedbok og bilagsinnboks (en).
window.PlummeI18n.register('en', {
  // ------------------------------------------------------ Purchases (purchases)
  'buy.remove': 'Remove',
  'buy.openPreview': 'Open preview',
  'buy.noPreview': 'No preview',
  'buy.savedInBackend': 'The receipt is saved.',
  'buy.open': 'Open',
  'buy.addMoreDocs': 'Add more receipts',
  'buy.addMoreDocsHelp': 'Attach more receipts or pages to the same purchase. All attached receipts are listed here.',
  'buy.uploadDoc': 'Upload receipt',
  'buy.uploadDocHelp': 'Attach the receipt or invoice for the purchase. You can drag in a file, choose one from your computer, or fetch a receipt from the Inbox.',
  'buy.dropOrPick': 'Drop or choose a receipt',
  'buy.storedIn': 'The PDF or image is stored in Firebase/the Inbox.',
  'buy.fromInbox': 'Get from Inbox',
  'buy.attachments': 'Attachments',
  'buy.pickFiles': 'Choose files',
  'buy.dropAttachments': 'Drop attachments here',
  'buy.attachmentsNote': 'Attachments are uploaded to the backend when the entry is saved.',
  'buy.supplierSearch': 'Search or add a supplier...',
  'buy.supplierSearchShort': 'Search or add a supplier',
  'buy.supplierClose': 'Close supplier selection',
  'buy.supplierNone': 'No suppliers found.',
  'buy.supplierNew': 'New supplier',
  'buy.name': 'Name',
  'buy.org': 'Company no.',
  'buy.email': 'Email',
  'buy.phone': 'Phone',
  'buy.accountClose': 'Close account selection',
  'buy.searchShort': 'Search ...',
  'buy.noAccountMatch': 'No account matches the search.',
  'buy.fromInboxRead': 'Fetched from the Inbox - SuperPlumma read what it could.',
  'buy.docHelp': 'The receipt is the till slip or invoice that documents the purchase. Drag in an image or a PDF - or tap to choose a file. SuperPlumma reads the date, amount, supplier and VAT, and suggests how the purchase should be posted.',
  'buy.dropReceipt': 'Drop the receipt here',
  'buy.dropReceiptHelp': 'Fetch the receipt from your files, or choose "Get from Inbox" to use a receipt that has already arrived by email. SuperPlumma reads the content automatically.',
  'buy.upload': 'Upload',
  'buy.type': 'Purchase type',
  'buy.typeHelp': 'Choose how the purchase should be registered. "Paid purchase" is a purchase that has already been paid. "Supplier invoice" is used when the invoice will be paid later or has been partly paid (it becomes accounts payable). "Drafts" shows purchases you have started but not posted yet.',
  'buy.description': 'Description',
  'buy.descriptionPh': 'E.g. subscription or travel',
  'buy.toggleVat': 'Switch between excl. and incl. VAT',
  'buy.amountExInc': 'Amount excl./incl. VAT',
  'buy.amountExIncHelp': 'Tap to switch whether you enter the amount excluding VAT (net) or including VAT (gross). Plumme converts between the two automatically. "Excl. VAT" is the cost itself, "incl. VAT" is the total you paid.',
  'buy.vatRate': 'VAT rate',
  'buy.vatRateHelp': 'The VAT rate on the purchase. 25 % is the standard rate, 15 % applies to foodstuffs, 12 % applies to passenger transport and accommodation among others, and 0 % is used for exempt purchases. VAT on a purchase is input VAT, which you can deduct.',
  'buy.pickCategory': 'Account/category',
  'buy.category': 'Category',
  'buy.categoryHelp': 'What kind of cost this is. The category decides which account the purchase is posted to, so it ends up correctly in the income statement and the tax return.',
  'buy.supplier': 'Supplier',
  'buy.accountFromHistory': 'Cost account suggested from earlier purchases with this supplier. You can change it on the purchase line.',
  'buy.date': 'Purchase date',
  'buy.invoiceNumber': 'Invoice number',
  'buy.invoiceNumberPh': 'E.g. 100245',
  'buy.dueDate': 'Due date',
  'buy.lines': 'Lines',
  'buy.linesHelp': 'Each line is one cost on the receipt, with its own amount, VAT rate and category. If the receipt has several different items or VAT rates, create one line per type. You can drag the lines to reorder them.',
  'buy.addLine': 'Add line',
  'buy.payment': 'Payment',
  'buy.paymentHelp': 'For a supplier invoice, choose whether the invoice has been paid. Unpaid invoices are saved as open accounts payable so payment can be registered later.',
  'buy.immediatePaymentHelp': 'A regular purchase has already been paid. Choose the account it was paid from and the payment date.',
  'buy.paid': 'Paid',
  'buy.unpaid': 'Unpaid',
  'buy.paidFrom': 'Paid from',
  'buy.choosePaymentSource': 'Choose payment source',
  'buy.paidDate': 'Payment date',
  'buy.paidDateHelp': 'The date the purchase was paid. The purchase date controls the accounting and VAT period for the purchase itself.',
  'buy.dateLabel': 'Date',
  'buy.addPartPayment': 'Add instalment',
  'buy.addPartPaymentHelp': 'Register another payment. The sum of the instalments is subtracted from the total - what is left is shown as "remaining".',
  'buy.remaining': 'Remaining',
  'buy.remainingHelp': 'The difference between the total and what you have registered as instalments. If it is 0, the purchase is fully settled.',
  'buy.preview': 'Preview',
  'buy.previewHelp': 'A preview of the receipt you have uploaded. If you have not uploaded one, you can do it here.',
  'buy.dropReceiptLong': 'Drop the receipt here - drag in an image or PDF, or tap to choose a file.',
  'buy.summaryHelp': 'The summary shows net, VAT and the total you pay.',
  'buy.saveDraft': 'Save draft',
  'buy.saveDraftHelp': 'Saves the purchase as a draft without posting it. Receipts and payments are not marked as posted until you complete the purchase.',
  'buy.title': 'Paid purchase',
  'buy.subtitle': 'Register a purchase - upload the receipt and we suggest the rest.',
  'buy.drafts': 'Drafts',
  'buy.draftsSub': 'Purchases and assets you have started but not posted yet',
  'buy.draftsSearchPh': 'Supplier, description, invoice no. or amount',
  'buy.showMore': 'Show more',
  'buy.noDrafts': 'No drafts',
  'buy.invoiceNoShort': 'Invoice no.',
  'buy.delete': 'Delete',
  'buy.deleteDraftTitle': 'Delete draft?',
  'buy.deleteDraftConfirm': 'Yes, delete the draft',
  'buy.deleteDraftBody': 'Are you sure you want to delete the draft for',
  'buy.resetTitle': 'Clear the form and start over',
  'buy.reset': 'Clear',
  'buy.howRegister': 'How do you want to register the purchase?',
  'buy.howRegisterSub': 'Feel free to upload the receipt first - then we suggest the rest for you.',
  'buy.stepByStep': 'Step by step',
  'buy.stepByStepHelp': 'Takes you through the purchase one part at a time - first the receipt, then date, lines and payment. Good when you want to take it slowly.',
  'buy.stepByStepShort': 'Receipt first, then date, lines and payment.',
  'buy.onePage': 'All on one page',
  'buy.onePageHelp': 'Shows the whole purchase form on a single page. Good when you are used to registering purchases and want everything in front of you.',
  'buy.onePageShort': 'The whole purchase form together.',
  'buy.toSteps': 'Switch to step-by-step',
  'buy.toOnePage': 'Switch to all on one page',
  'buy.back': 'Back',
  'buy.next': 'Next',
  'buy.backToVouchers': 'Back to transactions',
  'buy.salesType': 'Sale type',
  'buy.paidTo': 'Paid to',
  'buy.payOperating': 'Operating account',
  'buy.payCash': 'Cash',
  'buy.payPrivate': 'Private',
  'buy.privateDeposit': 'Private contribution',
  'buy.whatSold': 'What did you sell?',
  'buy.amountExVat': 'Amount excl. VAT',
  'buy.amountIncVat': 'Amount incl. VAT',
  'buy.vatLabel': 'VAT',
  'buy.otherSale': 'Other sale',
  'buy.invoiceOrQuote': 'Invoice / quote',
  'buy.switchMode': 'Switch mode',
  'buy.moreOptions': 'More options',
  'buy.postAs': 'Post as',
  // ------------------------------------------------ Paid purchase (nyttkjop)
  'buy.backendUploadNotReady': 'The backend upload is not ready.',
  'buy.multipleUploadedShowFirst': 'Several receipts were uploaded. Showing the first one here.',
  'buy.uploadFailed': 'Could not upload the receipt.',
  'buy.dropReceiptTitle': 'Drop the receipt here',
  'buy.dropReceiptSubtitle': "...we'll help you place it correctly. Drag in an image or PDF, or tap to choose a file.",
  'buy.attachedCount': '{count} receipts linked',
  'buy.uploading': 'Uploading...',
  'buy.chooseFile': 'Choose file',
  'buy.dropToUpload': 'Drop the receipt to upload',
  'buy.accountFallbackOperating': 'Operating account · 1920',
  'buy.accountFallbackCash': 'Cash',
  'buy.accountFallbackPrivate': 'Private outlay',
  'buy.accountFallbackCash1900': 'Cash - 1900',
  'buy.accountFallbackPrivate2060': 'Private - 2060',
  'buy.addSupplierQuery': 'Add «{query}»',
  'buy.chartNotConnected': 'The chart of accounts is not connected to storage.',
  'buy.accountAdded': 'The account has been added.',
  'buy.accountSaveFailed': 'Could not save the account.',
  'buy.chooseAccount': 'Choose account',
  'buy.forQuery': 'for «{query}»',
  'buy.newCustomAccountTitle': 'New custom account',
  'buy.saving': 'Saving...',
  'buy.saveAccount': 'Save account',
  'buy.accountNamePlaceholder': 'E.g. Software development',
  'buy.accountHelperText': 'The account becomes available in the account search and is mapped to the standard account for reporting and the annual close.',
  'buy.inventoryProduct': 'Stock item',
  'buy.notTracked': 'Not stock-tracked',
  'buy.quantityInStock': 'Quantity added to stock',
  'buy.inStockCount': '{n} in stock',
  'buy.inventoryLineToggle': 'Update inventory for this line',
  'buy.inventoryLineToggleHelp': 'Turn on when the purchase should increase the quantity of a registered stock item.',
  'buy.inventorySearchPlaceholder': 'Choose stock item',
  'buy.inventorySearch': 'Search by name, item number, SKU or EAN',
  'buy.inventorySearchEmpty': 'No stock-tracked items match the search.',
  'buy.inventoryOpenProducts': 'Open products',
  'buy.inventoryUnitsInStock': 'in stock',
  'inventoryPurchase.settingsTitle': 'Inventory on purchases',
  'inventoryPurchase.settingsHelp': 'Show an optional inventory control on purchase lines so a purchase can increase the quantity of a registered stock item.',
  'inventoryPurchase.offHelp': 'The inventory control is hidden on new purchases. Products and previous inventory movements are preserved.',
  'inventoryPurchase.migratedTitle': 'Inventory on purchases has been enabled',
  'inventoryPurchase.migratedText': 'This business already has products with automatic inventory tracking. Purchase-line inventory linking was enabled so the existing workflow can continue.',
  'inventoryPurchase.acknowledge': 'Got it',
  'inventoryPurchase.acknowledgeError': 'The confirmation could not be saved.',
  'inventoryPurchase.openSettings': 'Open settings',
  'inventoryPurchase.disableTitle': 'Turn off inventory on purchases?',
  'inventoryPurchase.disableConfirm': 'Turn off',
  'inventoryPurchase.disableWarning': 'The inventory control will be hidden on new purchases. Purchases can no longer be linked to stock-tracked products, and quantities may become incorrect unless they are checked and adjusted manually.',
  'inventoryPurchase.disableHistory': 'Existing products and historical inventory movements are not deleted. Count inventory and record any necessary adjustments manually.',
  'inventoryPurchase.enabledLabel': 'Inventory on purchases',
  'inventoryPurchase.disabledLabel': 'Inventory on purchases',
  'buy.noDescription': 'No description',
  'buy.attachmentFallback': 'Receipt',
  'buy.lockVatTitle': 'The VAT return period has been filed',
  'buy.lockYearTitle': 'The financial year is closed',
  'buy.lockBankTitle': 'The bank period is reconciled',
  'buy.lockVatTarget': 'the VAT return period',
  'buy.lockYearTarget': 'the annual close',
  'buy.lockBankTarget': 'the bank reconciliation',
  'buy.lockWarningText': '{title}. You can still change the description and cost account/category on the purchase, but the purchase date, amount, VAT code and payment fields are locked. Open or correct {target} if you need to change these fields.',
  'buy.lockVatWarningText': '{title}. The purchase date, amount and VAT code are locked, but the description, cost account/category and payment account can still be corrected. Open or correct {target} if the VAT basis must change.',
  'buy.backendSaveNotReady': 'The backend save is not ready.',
  'buy.needAtLeastOneLine': 'Add at least one purchase line.',
  'buy.needDescriptionAllLines': 'Enter a description on all lines before posting.',
  'buy.needContentForDraft': 'Add a line, supplier or a receipt before saving the draft.',
  'buy.needSupplierForInvoice': 'Choose a supplier or enter a supplier name before saving an instalment/supplier invoice.',
  'buy.draftSaved': 'Draft saved.',
  'buy.attachmentUpdated': 'The receipt has been updated.',
  'buy.invoiceRegisteredOpen': 'Invoice registered as an open supplier invoice.',
  'buy.purchaseBooked': 'Purchase posted! The receipt is now under Transactions.',
  'buy.purchaseSaveFailed': 'Could not save the purchase.',
  'buy.docsFetchedFromInbox': '{count} receipts fetched from the Inbox',
  'buy.fullPayment': 'Full payment',
  'buy.partPayment': 'Instalment',
  'buy.partPaymentWarning': 'An instalment is registered as a supplier invoice. The rest is posted as accounts payable on 2400 until it is paid.',
  'buy.partPaymentLabel': 'Instalment {n}',
  'buy.remainingSuffix': '· remaining',
  'buy.unpaidWillBeInvoice': 'Without a registered payment, this is saved as an open supplier invoice. You can register payment later.',
  'buy.forgotReceiptTitle': 'Forgot the receipt?',
  'buy.registerInvoice': 'Register invoice',
  'buy.bookPurchase': 'Post purchase',
  'buy.registerInvoiceHelp': 'Saves the invoice as an open accounts payable. It appears under the supplier, and you register payment once it has been paid.',
  'buy.bookPurchaseHelp': 'Saves the purchase in the accounts. The receipt ends up under «Transactions», and the amounts are posted to the correct accounts.',
  'buy.typeBadgeInvoice': 'Invoice',
  'buy.typeBadgeAsset': 'Asset',
  'buy.draftDeleteNotConnected': 'Deleting drafts is not connected to the backend.',
  'buy.draftDeleted': 'Draft deleted.',
  'buy.draftDeleteFailed': 'Could not delete the draft.',
  'buy.pageHelpDrafts': 'This is where you register everything the company buys. Choose «Drafts» in the dropdown menu to see purchases you have started but not posted yet.',
  'buy.draftsPageHelp': "Purchases you have started but not completed are saved here. Open a draft to continue, or delete the ones you don't need.",
  'buy.viewOptionsLabel': 'Display options',
  'buy.assetsLabel': 'Assets',
  'buy.noDraftsMatchSearch': 'No drafts match the search.',
  'buy.draftsEmptyHint': 'Purchases you have started and save as drafts appear here.',
  'buy.colSupplier': 'Supplier',
  'buy.noSupplier': 'No supplier',
  'buy.colType': 'Type',
  'buy.colInvoiceNo': 'Invoice no.',
  'buy.colDate': 'Date',
  'buy.colAmount': 'Amount',
  'buy.thisPurchaseFallback': 'this purchase',
  'buy.cannotBeUndone': '? This cannot be undone.',
  'buy.formReset': 'The form has been reset',
  'buy.editPurchaseSubtitle': 'Update the receipt and save the changes to the backend.',
  'buy.newPurchasePageHelp': 'This is where you register everything the company buys - goods, equipment, subscriptions, travel. Upload the receipt, and SuperPlumma reads the details and posts the cost to the correct account with the correct VAT.',
  'buy.defaultLineDescription': 'Purchase',
  'buy.customerFallback': 'Customer',
  'buy.supplierAndDateTitle': 'Supplier and date',
  'buy.supplierAndDateInvoiceHelp': "Who you bought from and when. The invoice date is the date on the invoice, and the due date is when it must be paid. The invoice number is the supplier's own number on the invoice.",
  'buy.supplierAndDatePurchaseHelp': 'The purchase date decides which accounting and VAT period the purchase falls into. Use the date on the receipt.',
  // ---------------------------------------- Purchase categories / chart of accounts
  'buy.katFixedAssets': 'Fixed assets / equipment',
  'buy.katRent': 'Rent',
  'buy.katPhoneInternet': 'Phone and internet',
  'buy.katSoftware': 'Software / subscription',
  'buy.katTravel': 'Travel and per diem',
  'buy.katRepresentation': 'Entertainment',
  'buy.acct4000': 'Raw materials and semi-finished goods',
  'buy.acct4300': 'Purchases of goods for resale',
  'buy.acct4500': 'External services and subcontractors',
  'buy.acct5000': 'Wages to employees',
  'buy.acct5400': "Employer's national insurance contributions",
  'buy.acct5900': 'Gifts to employees',
  'buy.acct6000': 'Depreciation',
  'buy.acct6100': 'Freight and transport costs',
  'buy.acct6200': 'Energy, electricity and heating',
  'buy.acct6300': 'Premises rent',
  'buy.acct6320': 'Waste removal, water, sewage, etc.',
  'buy.acct6340': 'Lighting, heating',
  'buy.acct6360': 'Cleaning',
  'buy.acct6400': 'Machine rental',
  'buy.acct6500': 'Tools and fixtures',
  'buy.acct6540': 'Fixtures and equipment',
  'buy.acct6550': 'Operating supplies',
  'buy.acct6560': 'Supplies',
  'buy.acct6600': 'Repair and maintenance of buildings',
  'buy.acct6690': 'Repair and maintenance, other',
  'buy.acct6700': 'Audit and accounting',
  'buy.acct6720': 'Legal assistance',
  'buy.acct6790': 'Other purchased services',
  'buy.acct6800': 'Office supplies',
  'buy.acct6810': 'IT/data costs',
  'buy.acct6820': 'Printed materials',
  'buy.acct6900': 'Telephone',
  'buy.acct6940': 'Postage',
  'buy.acct7000': 'Fuel for vehicles',
  'buy.acct7020': 'Vehicle maintenance',
  'buy.acct7040': 'Vehicle insurance and fees',
  'buy.acct7100': 'Mileage allowance',
  'buy.acct7140': 'Non-reportable travel expenses',
  'buy.acct7150': 'Per diem expenses',
  'buy.acct7160': 'Reportable travel expenses',
  'buy.acct7300': 'Selling costs',
  'buy.acct7320': 'Advertising',
  'buy.acct7350': 'Deductible entertainment expenses',
  'buy.acct7360': 'Non-deductible entertainment expenses',
  'buy.acct7400': 'Membership dues',
  'buy.acct7500': 'Insurance premium',
  'buy.acct7600': 'License, patent and royalty',
  'buy.acct7700': 'Other operating expenses',
  'buy.acct7770': 'Bank and card fees',
  'buy.acct7790': 'Other costs',
  'buy.acct8050': 'Interest income',
  'buy.acct8150': 'Interest expense',
  'buy.acct8300': 'Tax payable',
  'buy.fallbackCostName': 'Cost',
  'buy.fallbackAccountName': 'Account',
  'buy.grp40': 'Cost of goods',
  'buy.grp43': 'Goods for resale',
  'buy.grp45': 'Purchased services',
  'buy.grp50': 'Wages',
  'buy.grp54': "Employer's contribution",
  'buy.grp59': 'Personnel costs',
  'buy.grp60': 'Depreciation',
  'buy.grp61': 'Freight and transport',
  'buy.grp62': 'Energy and heating',
  'buy.grp63': 'Premises',
  'buy.grp64': 'Machine and equipment rental',
  'buy.grp65': 'Tools and fixtures',
  'buy.grp66': 'Repair and maintenance',
  'buy.grp67': 'Purchased services',
  'buy.grp68': 'Office costs',
  'buy.grp69': 'Telephone, postage, etc.',
  'buy.grp70': 'Vehicles',
  'buy.grp71': 'Travel and per diem',
  'buy.grp73': 'Sales and entertainment',
  'buy.grp74': 'Membership dues',
  'buy.grp75': 'Insurance',
  'buy.grp76': 'License and royalty',
  'buy.grp77': 'Other operating expenses',
  'buy.grp15': 'Accounts receivable',
  'buy.grp24': 'Accounts payable',
  'buy.groupAssets': 'Assets',
  'buy.groupEquityAndLiabilities': 'Equity and liabilities',
  'buy.groupIncome': 'Income',
  'buy.groupCostOfGoods': 'Cost of goods',
  'buy.groupPayrollAndPersonnel': 'Payroll and personnel costs',
  'buy.groupOtherOperating': 'Other operating expenses',
  'buy.groupFinanceAndTax': 'Finance and tax',
  'buy.groupAccountsFallback': 'Accounts',
  // ------------------------------------------------------- Trial balance
  'rep.trial.onlyMovement': 'Only show accounts with movement',
  'rep.trial.showInactive': 'Also show inactive accounts',
  'rep.trial.payrollLiability': 'Payroll payable',
  'rep.trial.holidayPayLiability': 'Holiday pay payable',
  'rep.trial.oneEmployee': '{n} employee',
  'rep.trial.employeeCount': '{n} employees',
  'rep.trial.otherPayrollLiability': 'All entries on 2930',
  'rep.trial.allAccountEntries': 'All entries on {account}',
  'rep.trial.payrollRun': 'Payroll run {period}',
  'rep.trial.term': 'Term {term}, {year}',
  'rep.trial.accrualYear': 'Accrual year {year}',
  // -------------------------------------------------- All vouchers / ledger

  // ------------------------------------------------- Inbox / voucher viewer
  'vehiclePolicy.dialogTitle': 'Vehicle and vehicle costs',
  'vehiclePolicy.intro': 'Choose how Plumme should treat fuel, workshop and other clear vehicle costs. This is a workflow setting for receipt suggestions and does not register a vehicle as an asset.',
  'vehiclePolicy.optionVat': 'Vehicle with VAT deduction',
  'vehiclePolicy.optionVatSub': 'The business owns or leases the vehicle, the vehicle type qualifies, and the cost relates to registered VAT-taxable activity.',
  'vehiclePolicy.optionNoVat': 'Vehicle without VAT deduction',
  'vehiclePolicy.optionNoVatSub': 'Suggest the vehicle cost without input VAT deduction.',
  'vehiclePolicy.optionManual': 'Review every receipt manually',
  'vehiclePolicy.optionManualSub': 'Plumme suggests the account, but leaves the VAT deduction for review.',
  'vehiclePolicy.validFrom': 'Effective from',
  'vehiclePolicy.noEndDateWarning': 'Without an end date, the choice remains active until you change it. A new choice automatically ends the previous one from the change date.',
  'vehiclePolicy.responsibility': 'I confirm that this information is correct and understand that I must update it if the vehicle is sold, the lease ends, or the vehicle type or use changes.',
  'vehiclePolicy.receiptTitle': 'Confirm the vehicle once',
  'vehiclePolicy.receiptText': 'Later fuel and workshop receipts can then receive the correct VAT suggestion automatically.',
  'vehiclePolicy.changeFromReceiptTitle': 'Update the vehicle rule?',
  'vehiclePolicy.changeFromReceiptText': 'You changed this vehicle receipt to 0% VAT deduction. Should that only apply to this receipt, or should Plumme treat vehicle costs without VAT deduction going forward because the vehicle was sold, the lease ended, or the deduction right no longer applies?',
  'vehiclePolicy.changeFromReceiptDate': 'The new rule will apply from {date}.',
  'vehiclePolicy.receiptOnly': 'This receipt only',
  'vehiclePolicy.updateToNoVat': 'Use 0% going forward',
  'vehiclePolicy.settingsTitle': 'Vehicle and vehicle costs',
  'vehiclePolicy.settingsText': 'Controls automatic suggestions for fuel, workshop and other clear vehicle costs. This setting does not post entries or create an asset or lease.',
  'vehiclePolicy.choose': 'Choose setting',
  'vehiclePolicy.change': 'Change setting',
  'vehiclePolicy.save': 'Save and apply',
  'vehiclePolicy.saved': 'The vehicle setting has been saved.',
  'vehiclePolicy.saveError': 'The vehicle setting could not be saved.',
  'vehiclePolicy.chooseError': 'Choose how vehicle receipts should be treated.',
  'vehiclePolicy.confirmError': 'Confirm that the business will keep this information up to date.',
  'vehiclePolicy.notConfigured': 'Not configured – vehicle receipts require review',
  'vehiclePolicy.activeFrom': 'Effective from',
  'vehiclePolicy.noEndDate': 'no end date',
  'vehiclePolicy.mode.vat_deductible': 'Vehicle with VAT deduction',
  'vehiclePolicy.mode.no_vat_deduction': 'Vehicle without VAT deduction',
  'vehiclePolicy.mode.manual_review': 'Manual review of every receipt',
  'buy.vatDeduction': 'Input VAT deduction',
  'buy.vatDeductionFull': '100%',
  'buy.vatDeductionNone': '0%',
  'buy.vatDeductionPartial': 'Partial',
  'buy.vatDeductionPercent': 'Deduction percentage',
  'buy.fixedAssetLine': 'Register this line as a fixed asset',
  'buy.fixedAssetLineHelp': 'The line is added to the fixed-asset register instead of being treated only as a cost.',
  'buy.fixedAssetFallback': 'Fixed asset',
  'buy.projectForLine': 'Project for this line',
  'sup.credit.created': 'The supplier credit note was posted.',
  'sup.credit.refunded': 'The refund was posted.',
  'sup.credit.title': 'Register supplier credit note',
  'sup.credit.refundTitle': 'Register credit-note refund',
  'sup.credit.action': 'Post credit note',
  'sup.credit.refundAction': 'Register refund',

});
